export default "__VITE_ASSET__Bbb9WfiS__"